export class User {
  id?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  securityGroups?: string;
  password?: string;
  photoUrl?: string;
  smsCellNumber?: string;
  employeeId?: string;
  deletedAt?: string;
  managerId?: string;
  suppressPresentationStarted?: boolean;
  devMode?: boolean;
  dashboard?: string;

  static unpackSecurityGroups(secGrpStr: string): Array<string> {
    return secGrpStr ? secGrpStr.replace(/[{}\s]/g, "").split(",") : [];
  }

  static packSecurityGroups(list: Array<string>): string {
    return list ? "{" + list.join(",") + "}" : "{}";
  }
}
